export type ColumnKind = 'saldo' | 'percent' | 'deltaAbsolute' | 'deltaPercent';

export interface AccountsColumn {
    label: string;
    kind: ColumnKind;
    /** The period being closed. Shaded, so the eye finds it among the comparison columns. */
    current?: boolean;
}

export interface AccountsCell {
    value: number | null;
    material?: boolean;
}

export type AccountStatus = 'open' | 'difference' | 'reconciled';

/** A block of the statement («Aktiven in CHF»). Repeats the column headings. */
export interface AccountsSectionRow {
    kind: 'section';
    id: string;
    label: string;
}

/** The heading of a group of positions. No figures; the group's total row carries them. */
export interface AccountsHeadingRow {
    kind: 'heading';
    id: string;
    label: string;
}

/** How many of a position's accounts stand in each status. */
export interface AccountsStatusCounts {
    reconciled: number;
    difference: number;
    open: number;
}

/** A position: collapsible, with the sum of its accounts. */
export interface AccountsGroupRow {
    kind: 'group';
    id: string;
    label: string;
    isExpanded: boolean;
    allReconciled?: boolean;
    /** Over ALL its accounts, whatever search and chips hide. Drawn as a pie in the status column. */
    statusCounts?: AccountsStatusCounts;
    values?: AccountsCell[];
}

export interface AccountsAccountRow {
    kind: 'account';
    id: string;
    number: string;
    label: string;
    values: AccountsCell[];
    status?: AccountStatus;
    marked?: boolean;
}

export interface AccountsTotalRow {
    kind: 'total';
    id: string;
    label: string;
    values: AccountsCell[];
    /** `root` closes a whole block (Total Aktiven) and is drawn stronger. */
    level?: 'group' | 'root';
}

/** A running subtotal of the statement (Bruttogewinn, EBIT, Jahresgewinn). */
export interface AccountsSubtotalRow {
    kind: 'subtotal';
    id: string;
    label: string;
    values: AccountsCell[];
}

export type AccountsRow =
    | AccountsSectionRow
    | AccountsHeadingRow
    | AccountsGroupRow
    | AccountsAccountRow
    | AccountsTotalRow
    | AccountsSubtotalRow;

export interface FilterChip {
    id: string;
    label: string;
    active: boolean;
    /** Not available now: the chip shows, takes no click and says why in `reason`. */
    disabled?: boolean;
    reason?: string;
}

export interface FilterGroup {
    id: string;
    align: 'start' | 'end';
    label?: string;
    chips: FilterChip[];
}
